const SocialIconWeb = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9716 2.10003C12.2894 2.66931 13.4115 3.60561 14.2091 4.78017C13.6208 4.98159 12.9698 5.1568 12.2677 5.29899C11.9686 4.05199 11.5225 2.95902 10.9716 2.10003Z"
        fill="currentColor"
      />
      <path
        d="M10.0701 3.34554C10.3929 3.95883 10.6692 4.69623 10.8759 5.52765C9.97251 5.64352 9.00747 5.70703 8 5.70703C6.99253 5.70703 6.02749 5.64352 5.12406 5.52765C5.33084 4.69623 5.60706 3.95883 5.92985 3.34554C6.68613 1.90862 7.48743 1.48828 8 1.48828C8.51257 1.48828 9.31388 1.90862 10.0701 3.34554Z"
        fill="currentColor"
      />
      <path
        d="M8 7.11328C6.90743 7.11328 5.85282 7.04261 4.85903 6.91124C4.76826 7.5675 4.71875 8.26347 4.71875 8.98828C4.71875 9.71309 4.76826 10.4091 4.85903 11.0653C5.85282 10.9339 6.90743 10.8633 8 10.8633C9.09257 10.8633 10.1472 10.9339 11.141 11.0653C11.2317 10.4091 11.2812 9.71309 11.2812 8.98828C11.2812 8.26347 11.2317 7.5675 11.141 6.91124C10.1472 7.04261 9.09257 7.11328 8 7.11328Z"
        fill="currentColor"
      />
      <path
        d="M10.8759 12.4489C9.97251 12.333 9.00747 12.2695 8 12.2695C6.99253 12.2695 6.02749 12.333 5.12406 12.4489C5.33084 13.2803 5.60706 14.0177 5.92985 14.631C6.68613 16.0679 7.48743 16.4883 8 16.4883C8.51257 16.4883 9.31388 16.0679 10.0701 14.631C10.3929 14.0177 10.6692 13.2803 10.8759 12.4489Z"
        fill="currentColor"
      />
      <path
        d="M3.47133 11.2956C3.36773 10.5597 3.3125 9.78628 3.3125 8.98828C3.3125 8.19028 3.36773 7.41684 3.47133 6.68092C2.61631 6.50863 1.82196 6.28902 1.10604 6.02987C0.716011 6.93756 0.5 7.93771 0.5 8.98828C0.5 10.0388 0.716011 11.039 1.10604 11.9467C1.82196 11.6875 2.61631 11.4679 3.47133 11.2956Z"
        fill="currentColor"
      />
      <path
        d="M1.7909 13.1964C2.37923 12.995 3.03021 12.8198 3.73232 12.6776C4.03142 13.9246 4.47746 15.0175 5.02841 15.8765C3.71061 15.3073 2.58849 14.371 1.7909 13.1964Z"
        fill="currentColor"
      />
      <path
        d="M14.2091 13.1964C13.4115 14.371 12.2894 15.3073 10.9716 15.8765C11.5225 15.0175 11.9686 13.9246 12.2677 12.6776C12.9698 12.8198 13.6208 12.995 14.2091 13.1964Z"
        fill="currentColor"
      />
      <path
        d="M14.894 11.9467C14.178 11.6875 13.3837 11.4679 12.5287 11.2956C12.6323 10.5597 12.6875 9.78628 12.6875 8.98828C12.6875 8.19028 12.6323 7.41684 12.5287 6.68092C13.3837 6.50863 14.178 6.28902 14.894 6.02987C15.284 6.93756 15.5 7.93771 15.5 8.98828C15.5 10.0388 15.284 11.039 14.894 11.9467Z"
        fill="currentColor"
      />
      <path
        d="M5.02841 2.10003C4.47746 2.95902 4.03142 4.05199 3.73232 5.29899C3.03021 5.1568 2.37923 4.98159 1.7909 4.78017C2.58849 3.60561 3.71061 2.66931 5.02841 2.10003Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconWeb };
